// src/modules/connect/config/connectConfig.js
/**
 * Neutral configuration module for Synex Connect.
 *
 * Provides base configuration and URLs for Connect services.
 * MUST NOT import connectClient, meetingSessionService, or meetingSession.
 */

// Normalize the Connect base URL (strip trailing slash).
const getConnectBaseUrl = () => {
  let url = process.env.REACT_APP_CONNECT_URL || "";
  if (url.endsWith("/")) url = url.slice(0, -1);
  return url;
};

export const CONNECT_BASE = getConnectBaseUrl();

export default {
  CONNECT_BASE,
};
